import { Component, ViewChild } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOTimeRanges } from "src/app/shared/models/OOTimeRanges.entity";
import { OOTimeRangeTimes } from "src/app/shared/models/OOTimeRangeTimes.entity";
import { TimeRangeSetupComponent } from "./time-range-setup/time-range-setup.component";

@Component({
	selector: "app-time-ranges",
	templateUrl: "./time-ranges.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class TimeRangesComponent {
	@ViewChild("timeRangeForm") timeRangeForm: TimeRangeSetupComponent;
	moment: any = moment;

	timeRangeSelected: OOTimeRanges;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	timeRangeDelete(rec: OOTimeRanges) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete the ${rec.name} time range?`,
			accept: async () => {
				this.venueService.timeRangeDelete(rec);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	timeRangeNew() {
		this.timeRangeSelected = new OOTimeRanges({
			venueKey: this.venueService.venueKey,
			active: true,
		});

		this.timeRangeSelected.OOTimeRangeTimes = presetTimeRangeDays(this.timeRangeSelected.key, this.venueService.venueKey);

		function presetTimeRangeDays(timeRangeKey: string, venueKey: number) {
			const trts: OOTimeRangeTimes[] = [];
			for (let i = 0; i < 7; i++) {
				trts.push(
					new OOTimeRangeTimes({
						venueKey: venueKey,
						timeRangeKey: timeRangeKey,
						day: i,
						startTime: undefined,
						startTime2: undefined,
						endTime2: undefined,
						endTime: undefined,
					})
				);
			}
			return trts;
		}
	}

	timeRangeSave(timeRange: OOTimeRanges) {
		this.venueService.timeRangesSave(timeRange);
	}
}
